import * as React from "react";
import { forwardRef } from "react";
const SvgCheckIcon = (props, ref) => /* @__PURE__ */ React.createElement("svg", { fill: "none", height: 16, viewBox: "0 0 16 16", width: 16, xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "m14 3.5-8.25 9-3.75-4.09091", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.5 }));
const ForwardRef = forwardRef(SvgCheckIcon);
export default ForwardRef;
